import React, { HTMLProps, useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { get, isArray } from 'lodash'
import { clearInput } from 'tennders-stracture/libs/utils'
import ClearInputButton from '../ClearInputButton'

export type TextInputProps = Omit<HTMLProps<HTMLInputElement>, 'ref' | 'onChange' | 'value' | 'form'> & {
  onSet?: (value: any) => void,
  value?: any,
  error?: string,
  name?: string,
  defaultValue?: string,
  autoCompleteOn?: boolean
}

const TextInput = (props: TextInputProps) => {
  const {
    onSet,
    required,
    disabled,
    readOnly,
    className,
    value,
    error,
    autoCompleteOn,
    defaultValue,
    name,
    ...rest
  } = props
  const [inputValue, setInputValue] = useState(null)
  const [cursor, setCursor] = useState(null)
  const ref = useRef(null)

  const onFormChange = (e) => {
    if (readOnly || disabled) {
      return
    }
    if (onSet) {
      setCursor(e.target.selectionStart)
      onSet(e.target?.value)
      setInputValue(e.target?.value)
    }
  }

  const handleClearInput = useCallback(() => clearInput(onSet, inputValue[0], setInputValue), [onSet, inputValue, setInputValue])

  useEffect(() => {
    if (value) {
      setInputValue([value])
    } else if (defaultValue) {
      setInputValue([defaultValue])
    } else {
      setInputValue('')
    }
  }, [value, defaultValue])

  const inputType = useMemo(() => rest?.type || 'text', [rest?.type])

  useEffect(() => {
    const input = ref.current
    if (input && inputType === 'text') {
      input.setSelectionRange(cursor, cursor)
    }
  }, [ref, cursor, inputType, inputValue])

  return (
    <div className="pos-rel">
      <input
        ref={ref}
        disabled={!!disabled || !!readOnly}
        required={!!required}
        readOnly={!!readOnly}
        className={`${className || 'form-input w-100'}${error ? ' error' : ''}${readOnly || disabled ? ' disabled' : ''}`}
        value={get(inputValue, 'length') > 0 ? isArray(inputValue) ? inputValue[0] : inputValue : ''}
        onChange={onFormChange}
        maxLength={255}
        autoComplete={autoCompleteOn ? 'on' : 'new-password'}
        type={inputType}
        name={name}
        onFocus={autoCompleteOn ? null : (e) => e.target.setAttribute('autoComplete', 'off')}
        {...rest}
      />
      <ClearInputButton clearInput={handleClearInput} showClearInput={get(inputValue, 'length') > 0 && !(!!disabled || !!readOnly)} />
    </div>

  )
}

export default React.memo(TextInput)
